import React from 'react';
import Hero from './components/enquiry-numbers/Hero';
import Main from './components/enquiry-numbers/Main';

const EnquiryNumbers = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default EnquiryNumbers;